import gql from 'graphql-tag';

export default gql`
query PromotionCategory(
    $id: Int!
    $sortBy: AdminProductOrder!
    $count: Int!
    $page: Int
) {
    adminProductCategoryById(id:$id) {
        id
        name
        parent_id
        url_key
        content
        is_enable
        sort
        date_from
        date_to
        show_in_menu
        keywords
        description
        is_promotion
        promotion_place
        is_homepage_prohibited
        products(
            sortBy: $sortBy
            first: $count
            page: $page
        ) {
            data {
                id
                name
            }
        }
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/promotionCategory.ts